<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'order-deduction',
  components: {
    PageTable,
  },
}
</script>